"use client";

import PageSection from "@/app/(core)/components/PageSection";
import SectionHeader from "@/app/(core)/components/SectionHeader";
import WhyWereDifferentSection from "@/app/(core)/components/WhyWereDifferentSection";
import WaveBanner from "@/app/components/footer/components/WaveBanner";
import { darken, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import FaqModule from "./components/faq/FaqModule";

export default function AboutContent() {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");
  return (
    <main>
      {/* 1. Features (team, mission, value, etc.) - now first section */}
      <WhyWereDifferentSection firstSection={true} />
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 2. FAQ */}
      <PageSection variant="light" minHeight={false}>
        <SectionHeader
          title="Frequently Asked Questions"
          subTitle="If you don't find what you're looking for, contact us using the form at the bottom of the page!"
          align="center"
        />
        <FaqModule />
      </PageSection>
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? theme.colors.dark[9]
            : darken(theme.colors.darkblue[9], 0.2)
        }
      />
    </main>
  );
}
